import React from 'react';

import { Link } from 'react-router-dom';

import { MdErrorOutline } from 'react-icons/md';

import { BoxAuth, PageTitle } from './style';

import Breadcumbs from '~/components/Breadcumbs';

const Page404 = () => {
  return (
    <>
      <Breadcumbs path="/" pathTitle="404 - Página não existe" />
      <PageTitle>
        <span>404 - Página não existe</span>
      </PageTitle>
      <BoxAuth>
        <MdErrorOutline />
        <h4>Não foi possível encontrar esta página.</h4>
        <p>Por favor, tente uma das páginas a seguir:</p>
        <Link to="/"> Principal</Link>
      </BoxAuth>
    </>
  );
};

export default Page404;
